var educationSeachpage = {
  init: function () {
    var lang = $('html').attr('lang');

    function createFlag(option) {
      return "<img class='flag-img' src='" + option.IconUri + "' style='width:24px;height:20px' aria-hidden='true' />";
    }

    function getInputWrapper() {
      return $('.selectize-input');
    }

    function getInput() {
      return $('.selectize-input').find('input');
    }

    function getFlagImage() {
      return $('.selectize-input').find('img');
    }

    function hideResults() {
      $('.js-result-container').hide();
    }

    function getCrossButton() {
      return $('#js-clear-selected-country');
    }

    $('.show-text').keyup(function (e) {
      if ($('.show-more').css('display') === 'inline') {
        e.stopPropagation();
        var maxHeight = infoText[0].scrollHeight;
        infoText.animate({
          height: maxHeight,
        });
        infoText.css('max-height', 'none');
        $('.show-less').show();
        $('.show-more').hide();
        infoText[0].setAttribute('aria-expanded', 'true');
        infoText.removeClass('expandable');
      } else if ($('.show-less').css('display') === 'inline') {
        e.stopPropagation();
        if ($(window).width() < 992) {
          infoText.animate({
            height: '115px',
          });
        } else {
          infoText.animate({
            height: '240px',
          });
        }
        $('.show-less').hide();
        $('.show-more').show();
        infoText[0].setAttribute('aria-expanded', 'false');
        infoText.addClass('expandable');
      }
    });
  },
};

var educationComparison = {
  init: function () {
    $('[data-toggle="tooltip"]').tooltip();
  },
};

var bedomningCountrySearch = {
  init: function () {
    var currentIndex = -1; // Variable to track the current index of highlighted item
    var $dropdownItems = $('#dropdownMenu li'); // Cache dropdown items for efficiency

    var dropdownButton = $('#dropdownButton');
    var input = $('#comboboxInput');
    var iconDownArrow = dropdownButton.find('.icon-triangel-pil-ned');
    var iconUpArrow = dropdownButton.find('.icon-triangel-pil-upp');

    // Function to handle filtering of dropdown options
    function filterDropdown() {
      var searchValue = $('#comboboxInput').val().toLowerCase();

      // Show the dropdown menu if it isn't already visible
      if (!$('#dropdownMenu').hasClass('open')) {
        $('#dropdownMenu').addClass('open').show();
      }

      // Filter the dropdown items based on the text in the .namn span
      $dropdownItems.each(function () {
        var optionText = $(this).find('.namn').text().toLowerCase(); // Search within the .namn span
        $(this).toggle(optionText.indexOf(searchValue) > -1);
      });

      var visibleItems = $dropdownItems.filter(':visible');
      if (visibleItems.length === 0) {
        $('.emptySearch').show();
      } else {
        $('.emptySearch').hide();
      }
    }

    // Update input value and navigate when an option is clicked
    $(document).on('click', '.dropdown-option', function (e) {
      e.preventDefault();
      var selectedOption = $(this).find('.namn').text();
      $('#comboboxInput').val(selectedOption);

      var url = $(this).find('a').attr('href');
      window.location.href = url;
      $('#dropdownMenu').hide();
      currentIndex = -1;
    });

    $('#comboboxInput').on('keydown', function (e) {
      var visibleItems = $('#dropdownMenu li:visible');

      if (e.key === 'ArrowDown') {
        currentIndex = (currentIndex + 1) % visibleItems.length;
        highlightOption(visibleItems);
      } else if (e.key === 'ArrowUp') {
        currentIndex = (currentIndex - 1 + visibleItems.length) % visibleItems.length;
        highlightOption(visibleItems);
      } else if (e.key === 'Tab') {
        $('#dropdownMenu').hide();
      } else if (e.key === 'Enter' && currentIndex !== -1) {
        var selectedOption = visibleItems.eq(currentIndex).find('.namn').text();
        $('#comboboxInput').val(selectedOption);

        var url = visibleItems.eq(currentIndex).find('a').attr('href');
        window.location.href = url;

        $('#dropdownMenu').hide();
        currentIndex = -1;
      }
    });

    $('#comboboxInput').on('click', function (e) {
      showHideMenu();
    });

    $('#comboboxInput').on('keyup', function (e) {
      var charCode = event.keyCode;
      if (charCode == 9) {
        return;
      }
      showMenu();

      // Letters including åäö
      var charKey = e.key;
      if (
        (charKey >= 'A' && charKey <= 'Z') || // A-Z
        (charKey >= 'a' && charKey <= 'z') || // a-z
        charKey === 'å' ||
        charKey === 'Å' || // å (lowercase and uppercase)
        charKey === 'ä' ||
        charKey === 'Ä' || // ä (lowercase and uppercase)
        charKey === 'ö' ||
        charKey === 'Ö' // ö (lowercase and uppercase)
      ) {
        filterDropdown();
      }

      // Arrow down
      if (charCode == 40) {
        var visibleItems = $('#dropdownMenu li:visible');
        if (!currentIndex && visibleItems.length > 0) {
          currentIndex = -1;
        }
        if (charCode === 40 && currentIndex <= 0) {
          currentIndex = 0;
          highlightOption(visibleItems);
        }
      }
      //Delete or backspace
      if (charCode == 46 || charCode == 8) {
        var select_land = $('#comboboxInput').val();
        var original_land = $('#comboboxInput').attr('value');
        var flag_img = $('#input-group-combobox').find('.flag-img');
        if (select_land != original_land) {
          flag_img.css('visibility', 'hidden');
        } else if (select_land.trim().length > 0 && select_land.trim() === original_land.trim()) {
          flag_img.css('visibility', 'visible');
        }
      }
    });

    // Highlight the currently selected option in the dropdown
    function highlightOption(visibleItems) {
      visibleItems.removeClass('active'); // Remove active class from all items
      visibleItems.eq(currentIndex).addClass('active'); // Add active class to current item
      visibleItems.eq(currentIndex).get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Open/close dropdown on button click
    $('#dropdownButton').on('click', function () {
      showHideMenu();
    });

    // Toggle menu
    function showHideMenu() {
      if (!$('#dropdownMenu').hasClass('open')) {
        showMenu();
      } else {
        hideMenu();
      }
    }

    function hideMenu() {
      dropdownButton.attr('aria-expanded', false);
      input.attr('aria-expanded', false);

      $('#dropdownMenu').removeClass('open').hide();

      iconDownArrow.show();
      iconUpArrow.hide();
    }

    function showMenu() {
      dropdownButton.attr('aria-expanded', true);
      input.attr('aria-expanded', true);

      $('#dropdownMenu').addClass('open').show();
      iconDownArrow.hide();
      iconUpArrow.show();
    }

    // Close dropdown if clicked outside of it
    $(document).on('click', function (e) {
      if (!$(e.target).closest('.input-group, #dropdownMenu').length) {
        if ($('#dropdownMenu').hasClass('open')) {
          showHideMenu();
        }
      }
    });
    $('input[name="filter-option"]').on('change', function () {
      optionChange();
      $('input[name="filter-option"]').parent().removeClass('btn-info');
      $('input[name="filter-option"]').parent().removeClass('active');
      $('input[name="filter-option"]:checked').parent().addClass('active');
    });
    $('input[name="filter-region-option"]').on('change', function () {
      optionChange();
      $('input[name="filter-region-option"]').parent().removeClass('btn-info');
      $('input[name="filter-region-option"]').parent().removeClass('active');
      $('input[name="filter-region-option"]:checked').parent().addClass('active');
    });
    function optionChange() {
      var selectedOption = $('input[name="filter-option"]:checked').val();
      var selectedRegionOption = $('input[name="filter-region-option"]:checked').val();
      var firstRegion = $('input[name="filter-region-option"]').val();
      if (firstRegion == undefined) {
        if (selectedOption === '0') {
          $('li.result-item').show();
        } else {
          $('li.result-item').each(function () {
            if ($(this).attr('data-edu-level') == selectedOption) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        }
      } else {
        if (selectedOption === '0' && selectedRegionOption === firstRegion) {
          $('li.result-item').show();
        } else if (selectedOption === '0') {
          $('li.result-item').each(function () {
            if ($(this).attr('data-region') == selectedRegionOption) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        } else if (selectedRegionOption === firstRegion) {
          $('li.result-item').each(function () {
            if ($(this).attr('data-edu-level') == selectedOption) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        } else {
          $('li.result-item').each(function () {
            if ($(this).attr('data-edu-level') == selectedOption && $(this).attr('data-region') == selectedRegionOption) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        }
      }
      $('span.resultCount').html($('li.result-item:visible').length);
    }
  },
};

$(document).ready(function () {
  if ($('.combobox-countries').length) {
    bedomningCountrySearch.init();
  }

  if ($('.bedomnings-jamforelse-tjanst').length) {
    educationSeachpage.init();
  } else if ($('.bedomnings-tjanst-comparison-page').length) {
    educationComparison.init();
  }

  $('input[id="comboboxInput"]').focus();
});
